"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/map");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/filter");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getMyOrganizationsFailed = exports.getMyOrganizationsResponse = exports.getMyOrganizations = exports.getMyOrganizationsEpicIAMUX = exports.getMyCurrentOrganizationFailed = exports.getMyCurrentOrganizationResponse = exports.getMyCurrentOrganization = exports.getMyCurrentOrganizationEpic = void 0;

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _Observable = require("rxjs/Observable");

var _operators = require("rxjs/operators");

var _observableErrorHandler = require("../../../redux/observableErrorHandler");

var _ICurrentUser = require("../../models/ICurrentUser");

var _UserActions = require("../../models/UserActions");

var _requireAuthentication = require("../requireAuthentication");

var _userApi = require("../userApi");

var _userRegistry = require("../userRegistry");

var getMyCurrentOrganizationEpic = function getMyCurrentOrganizationEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(_UserActions.UserActions.getMyCurrentOrganization).pipe((0, _filterInstanceProperty(_operators))((0, _requireAuthentication.requireAuthentication)(store)), (0, _operators.switchMap)(function (action) {
    if (window !== top) {
      return _Observable.Observable.of({
        type: _UserActions.UserActions.getMyCurrentOrganizationResponse,
        payload: {}
      });
    }

    return ajax(_userApi.getMyOrganizationApiUrl).pipe((0, _mapInstanceProperty2(_operators))(function (payload) {
      return {
        type: _UserActions.UserActions.getMyCurrentOrganizationResponse,
        payload: payload.response
      };
    }), (0, _operators.catchError)((0, _observableErrorHandler.errorHandler)(_UserActions.UserActions.getMyCurrentOrganizationFailed, action)));
  }));
};

exports.getMyCurrentOrganizationEpic = getMyCurrentOrganizationEpic;

_userRegistry.userRegistry.addEpic('getMyCurrentOrganizationEpic', getMyCurrentOrganizationEpic);

var getMyCurrentOrganization = function getMyCurrentOrganization(state) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    isCurrentOrgLoading: true,
    isCurrentOrgLoadingError: false
  });
};

exports.getMyCurrentOrganization = getMyCurrentOrganization;

_userRegistry.userRegistry.add(_UserActions.UserActions.getMyCurrentOrganization, getMyCurrentOrganization);

var getMyCurrentOrganizationResponse = function getMyCurrentOrganizationResponse(state, action) {
  if (action.payload === undefined) {
    return state;
  }

  var nextState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    currentOrg: action.payload,
    isCurrentOrgLoading: false
  });
  return nextState;
};

exports.getMyCurrentOrganizationResponse = getMyCurrentOrganizationResponse;

_userRegistry.userRegistry.add(_UserActions.UserActions.getMyCurrentOrganizationResponse, getMyCurrentOrganizationResponse);

var getMyCurrentOrganizationFailed = function getMyCurrentOrganizationFailed(state) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    isCurrentOrgLoading: false,
    isCurrentOrgLoadingError: true
  });
};

exports.getMyCurrentOrganizationFailed = getMyCurrentOrganizationFailed;

_userRegistry.userRegistry.add(_UserActions.UserActions.getMyCurrentOrganizationFailed, getMyCurrentOrganizationFailed);

var getMyOrganizationsEpicIAMUX = function getMyOrganizationsEpicIAMUX(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(_UserActions.UserActions.getMyOrganizations).pipe((0, _filterInstanceProperty(_operators))((0, _requireAuthentication.requireAuthentication)(store)), (0, _operators.switchMap)(function (action) {
    if (window !== top) {
      return _Observable.Observable.of({
        type: _UserActions.UserActions.getMyCurrentOrganizationResponse,
        payload: {}
      });
    }

    return ajax((0, _objectSpread2.default)({
      method: 'POST'
    }, (0, _userApi.getMyOrganizationsApiUrl)())).pipe((0, _mapInstanceProperty2(_operators))(function (payload) {
      return {
        type: _UserActions.UserActions.getMyOrganizationsResponse,
        payload: mapLegacyCurrentUser(payload.response)
      };
    }), (0, _operators.catchError)((0, _observableErrorHandler.errorHandler)(_UserActions.UserActions.getMyOrganizationsFailed, action)));
  }));
};

exports.getMyOrganizationsEpicIAMUX = getMyOrganizationsEpicIAMUX;

_userRegistry.userRegistry.addEpic('getMyOrganizationsEpic', getMyOrganizationsEpicIAMUX);

var mapLegacyCurrentUser = function mapLegacyCurrentUser(currentUser) {
  var _context;

  if (currentUser === undefined) {
    return {
      value: []
    };
  }

  if (!(0, _isArray.default)(currentUser.Organizations)) {
    return {
      value: []
    };
  }

  return {
    value: (0, _map2.default)(_context = currentUser.Organizations).call(_context, function (org) {
      return {
        tenantId: org.tenantId,
        displayName: org.displayName,
        isHomeTenant: 'isHomeTenant' in org ? !!org.isHomeTenant : org.orgAction === _ICurrentUser.OrgAction.homeTenant,
        countryCode: ''
      };
    })
  };
};

var getMyOrganizations = function getMyOrganizations(state) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    isOrganizationsByIdLoading: state.organizationsById.size === 0,
    isOrganizationsByIdLoadingError: false
  });
};

exports.getMyOrganizations = getMyOrganizations;

_userRegistry.userRegistry.add(_UserActions.UserActions.getMyOrganizations, getMyOrganizations);

var getMyOrganizationsResponse = function getMyOrganizationsResponse(state, action) {
  var _context2, _context3, _context4;

  if (action.payload === undefined) {
    return state;
  }

  var mappedOrganizations = (0, _map2.default)(_context2 = action.payload.value).call(_context2, function (item) {
    return [item.tenantId, item];
  });
  var nextState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    organizationsById: new _map.default((0, _concat.default)(_context3 = []).call(_context3, (0, _toConsumableArray2.default)((0, _from.default)(state.organizationsById)), (0, _toConsumableArray2.default)(mappedOrganizations))),
    organizations: (0, _map2.default)(_context4 = action.payload.value).call(_context4, function (item) {
      return item.tenantId;
    }),
    isOrganizationsByIdLoading: false
  });
  return nextState;
};

exports.getMyOrganizationsResponse = getMyOrganizationsResponse;

_userRegistry.userRegistry.add(_UserActions.UserActions.getMyOrganizationsResponse, getMyOrganizationsResponse);

var getMyOrganizationsFailed = function getMyOrganizationsFailed(state) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    isOrganizationsByIdLoading: false,
    isOrganizationsByIdLoadingError: true
  });
};

exports.getMyOrganizationsFailed = getMyOrganizationsFailed;

_userRegistry.userRegistry.add(_UserActions.UserActions.getMyOrganizationsFailed, getMyOrganizationsFailed); // Uncomment when not relying on IAMUX controller for GetTenantsByKey

/*export const getMyOrganizationsEpic: Epic<
  IUserAction<AnyPayload>,
  IRootUserState
> = (
  action$: ActionsObservable<IUserAction>,
  store: MiddlewareAPI<IRootUserState>,
  { ajax }: { ajax: AjaxCreationMethod }
): Observable<IUserAction> => {
  return action$.ofType(UserActions.getMyUserRequest).pipe(
    switchMap((action: IUserAction) => {
      return ajax({
        method: 'POST',
        url: getMyOrganizationsApiUrl
      }).pipe(
        map((payload: IODataListResponse<IGuestOrganization>) => {
          return {
            type: UserActions.getMyOrganizations,
            payload: payload.response
          } as IUserAction<IGuestOrganization>;
        }),
        catchError(
          errorHandler<IUserAction>(
            UserActions.getMyOrganizationsFailed,
            action
          )
        )
      );
    })
  );
};
registry.addEpic('getMyOrganizationsEpic', getMyOrganizationsEpic);*/